import { render, staticRenderFns } from "./ServiceData.vue?vue&type=template&id=3b7715f6&"
import script from "./ServiceData.vue?vue&type=script&lang=js&"
export * from "./ServiceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports